import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { HardHat, ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-navy text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="h-9 w-9 rounded-md bg-brandblue flex items-center justify-center"><HardHat className="h-5 w-5" strokeWidth={2.5} /></div>
            <div className="font-display font-bold text-lg">BuildTrack</div>
          </Link>
          <Link to="/register" className="text-sm text-slate-300 hover:text-white inline-flex items-center gap-1"><ArrowLeft className="h-4 w-4" /> Back</Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-8 md:py-12">
        <div className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-2">Legal</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900 tracking-tight">Privacy policy</h1>
        <p className="text-sm text-slate-500 mt-1.5">Last updated: February 2026</p>

        <Card className="mt-8 p-6 md:p-8 space-y-6 border border-border shadow-sm text-slate-700 text-sm leading-relaxed">
          <Section title="What we collect">
            Your name and email (for the account), and the project data you enter (projects, trades, quotes, payments, uploaded photos/invoices/receipts).
          </Section>
          <Section title="Who sees your data">
            Only you. Every project, trade, payment and file is scoped to your account. We do not sell or share your data with third parties.
          </Section>
          <Section title="How we store it">
            Data lives in an encrypted database and file store. Passwords are hashed with bcrypt — never stored in plaintext.
          </Section>
          <Section title="Cookies & tokens">
            Sign-in uses a JWT stored on your device (localStorage). No third-party ad trackers.
          </Section>
          <Section title="Your rights">
            You can export your data or delete your account at any time by emailing support. Deletion removes projects, trades, payments and file references from our database.
          </Section>
          <Section title="Contact">
            privacy@buildtrack.example
          </Section>
        </Card>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-lg font-semibold text-slate-900 mb-2">{title}</h2>
      <div className="text-slate-600">{children}</div>
    </div>
  );
}
